import { Grid, Typography } from '@mui/material';
import { EmailField, FunctionField, SimpleShowLayout, TextField } from 'react-admin';
import { User } from 'src/models';

import { UserAccountList } from './UserAccountList';

export const UserInformationShow = () => {
  return (
    <Grid container direction='row'>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>User Information</Typography>
        </SimpleShowLayout>
      </Grid>
      <Grid item md={12}>
        <Grid container md={6}>
          <Grid item md={5}>
            <SimpleShowLayout>
              <TextField source='firstName' label='First Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={2}>
            <SimpleShowLayout>
              <TextField source='middleName' label='Middle Name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={4}>
            <SimpleShowLayout>
              <TextField source='lastName' label='Last name' />
            </SimpleShowLayout>
          </Grid>
          <Grid item md={1}>
            <SimpleShowLayout>
              <TextField source='suffix' label='Suffix' />
            </SimpleShowLayout>
          </Grid>
        </Grid>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <EmailField source='email' label='Email' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='phoneNumber' label='Phone Number' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField source='signUpStatus' label='Sign Up Status' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <FunctionField
            render={(user: User) => <span>{user.isMfaEnabled ? 'Enabled' : 'Disabled'}</span>}
            label='MFA Status'
          />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={12}>
        <UserAccountList />
      </Grid>
    </Grid>
  );
};
